module.exports = function() {
  return new Worker(__webpack_public_path__ + "8adb948e2e639c141f88.worker.js");
};